import {useMemo} from 'react';
import {useCheckoutHashDetails} from '../app-checkout/CheckoutHashDetailsProvider';

export const useAppCheckoutEntryDetails = () => {
  const request = useCheckoutHashDetails();
  return useCheckoutEntryDetails({
    jwt: request?.jwt,
    rawConsentConfig: request?.rawConsentConfig,
  });
};

export type CheckoutExperiment = {
  experimentKey: string;
  variantKey: string;
};

export type CheckoutEntryDetails = {
  jwtPayload?: {
    basketId: string;
    campaignKey: string;
    customData: {
      customerId: number;
      device: string;
      eligiblePromotionIds: string[];
      consent: object;
    };
    shopId: number;
    experiments?: CheckoutExperiment[];
  };

  appConfig?: {
    ga_session_id: string;
    consent: Record<string, boolean>;
    app?: {
      adid: string;
      android_id: string;
      app_instance_id: string;
      app_version: string;
      firebase_app_id: string;
      gps_adid: string;
      idfa: string;
      idfv: string;
    };
  };
};

export const useCheckoutEntryDetails = ({
  jwt,
  rawConsentConfig,
}: {
  jwt?: string;
  rawConsentConfig?: string;
}): CheckoutEntryDetails => {
  const jwtPayload = useMemo(() => {
    const payload = jwt?.split('.')[1];
    const decoded = payload ? atob(payload) : undefined;

    try {
      const parsed = decoded
        ? (JSON.parse(decoded) as CheckoutEntryDetails['jwtPayload'])
        : undefined;

      return parsed;
    } catch (_e) {
      return undefined;
    }
  }, [jwt]);

  const appConfig = useMemo(() => {
    if (!rawConsentConfig) return undefined;
    try {
      const parsed = JSON.parse(rawConsentConfig);
      return parsed as CheckoutEntryDetails['appConfig'];
    } catch (_e) {
      return undefined;
    }
  }, [rawConsentConfig]);

  return {
    jwtPayload,
    appConfig,
  };
};
